import BigNumber from "bignumber.js";

export class Config {
  pools: string[] = [];
  poolReservedRate: { [pool: string]: BigNumber } = {};
  poolPaused: { [pool: string]: boolean } = {};
  // quoteDecimal: number;
  initialMarginRiskRate: BigNumber;
  // liquidateRate: BigNumber;
  // clearRate: BigNumber;
  // liquidationReward: BigNumber;
  riskFreeRate: BigNumber;
  priceRatio: BigNumber;
  priceRatio2: BigNumber;
  priceRatioUtilization: BigNumber;
  spotFee: BigNumber;
  optionFee: BigNumber;
  minPremium: BigNumber;
  exerciseFeeRate: BigNumber;
  profitFeeRate: BigNumber;
  // Vault public vault;
  // address public quote;
  // address public feeAccount;
  // bool public initialized;

  getPools() {
    return this.pools;
  }

  getPoolReservedRate(pool: string) {
    return this.poolReservedRate[pool] || new BigNumber(0);
  }

  setPoolReservedRate(pool: string, reservedRate: BigNumber) {
    this.poolReservedRate[pool] = reservedRate;
  }

  getPoolPaused(pool: string) {
    return this.poolPaused[pool] || false;
  }

  setPoolPaused(pool: string, paused: boolean) {
    this.poolPaused[pool] = paused;
  }

  getPoolReservedRateForTrade(pool: string): [boolean, BigNumber] {
    return [this.getPoolPaused(pool), this.getPoolReservedRate(pool)];
  }
}
